module.exports = {
    "orientation": {
        "landscape": "landscape",
        "portrait": "portrait"
    },
    "maxWidth": 1280,
    "maxHeightLandscape": 800,
    "minWidthLandscape": 800,
    "minHeightLandscape": 560,
    "maxRatioLandscape": 2,
    "deviceType": {
        "desktop": "desktop",
        "tablet": "tablet",
        "mobile": "mobile"
    },
    "preferredRatio": {
        "landscape": "16/10",
        "portrait": "9/16"
    },
    "screenWidthLimits": {
        "landscape": {
            "mobile": 860,
            "tablet": 1280
        },
        "portrait": {
            "mobile": 480,
            "tablet": 800
        }
    },
    "nwpHeaders": {
        "desktop": 82,
        "tablet": 72,
        "mobile": 56
    },
    "unavailableHeight": {
        "desktop": 100,
        "tablet": 80,
        "mobile": 60
    }
}
;